import React from "react";
import logo from "../../img/kl-logo-white.png";
import Layout from "../../components/Layout";
import SignInForm from "../../components/SignIn";

const SignInPage = () => (
  <div className="sign-in-page">
    <img src={logo} alt="Kristie Lengel" />
    <h1 className="header-title">Kristielengel.com</h1>
    <SignInForm />
  </div>
);

const SignInFinal = () => (
  <Layout>
    <SignInPage />
  </Layout>
);

export default SignInFinal;
